import { render, staticRenderFns } from "./Dashboard_AL.vue?vue&type=template&id=c522afb6&scoped=true&"
import script from "./Dashboard_AL.vue?vue&type=script&lang=js&"
export * from "./Dashboard_AL.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_AL.vue?vue&type=style&index=0&id=c522afb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522afb6",
  null
  
)

export default component.exports